
import { Component,  Input, ViewEncapsulation,Output,EventEmitter,ElementRef,  HostListener} from "@angular/core";

import { MultiSelect } from "../../../../../UI/src/app/shared/job-search/job-results.dto";



@Component({
selector : 'sts-multi-select',
templateUrl : './multiselect.component.html',

encapsulation: ViewEncapsulation.None
})
export class multiselectComponent {
    searchText : string ='';
    ItemNotFound : boolean= false;
   focused : boolean = false;
   filteredMultiSelectItems : MultiSelect[]=[];
    selectedMultiSelectItems : MultiSelect[]=[];
    
    @Input() inputId : string =''
    @Input() inputName : string =''
    @Output() SelectedItems = new EventEmitter<MultiSelect[]>();
    multiSelectModelData :MultiSelect[]=[];
    @Input() inputPlaceholder : string='';
    @Input() allowUserInput : boolean = false;
    @Input()
    set multiSelectModel(multiSelectModel: MultiSelect[]) {
        this.multiSelectModelData=multiSelectModel;
    
    }
    @Input()
    set setSelectedItems(setSelectedItems: MultiSelect[]) {
        this.selectedMultiSelectItems=setSelectedItems;
    
    }
    constructor(private el: ElementRef) { }

    @Output() public onKeyPress = new EventEmitter();
    @HostListener('keypress', ['$event'])
    @HostListener('paste', ['$event'])
    public onKeypress(event: any) {
        const k=event.keyCode;
        //Allowing space, comma , hash, dot, plus and dash special characters remaining special characters are preventing
        if ( k !== 32 && k !== 35 && k !== 43 && k !== 44 &&  k !== 45 && k !==46) {
            return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57));
          }
        this.onKeyPress.emit(event);
    }

    @Output() public onFocusOut  = new EventEmitter();
  
    @HostListener('document:click', ['$event.target'])
    public onClick(target: any) {
    
        const clickedInside = this.el.nativeElement.contains(target);
       
        if (!clickedInside) {
          this.onFocusOut.emit(target);
          this.filteredMultiSelectItems=[];
          this.focused=false;
          this.ItemNotFound=false;
          this.searchText='';
        }
        else{
            this.inputfocus(target);
        }
    }

    inputkeydown(event){
    
          var KeyID = event.keyCode;
          switch(KeyID)
          {
              case 8:
                     event.preventDefault();
                      if(this.searchText !== ''){
                        this.searchText=this.searchText.substring(0,(this.searchText.length-1));
                      }
                      else{
                        if(this.selectedMultiSelectItems.length>0){
                            this.selectedMultiSelectItems.pop();
                            this.SelectedItems.emit(this.selectedMultiSelectItems);
                        }
                        else{
                          window.setTimeout(()=>document.getElementById("Custom_"+this.inputId).focus(),100);
                        }
                      }
                     
                      break;
            
           
              default:
              break;
          }
      }
      inputfocusout(status) {
        if(!status){
            if(this.allowUserInput){
                if(this.searchText !== '')
                   {
                       this.selectedMultiSelectItems.push({'Id' : this.searchText, 'name' : this.searchText});
                       this.SelectedItems.emit(this.selectedMultiSelectItems);
                       this.searchText='';
                   }
               }
        }
       
      }
    inputfocus(event) {
        if(!this.allowUserInput){
            if(this.searchText == ""){
            this.focused=true;
            this.filteredMultiSelectItems=this.multiSelectModelData;
            this.ItemNotFound=false;
         
            for(let selecteditem of this.selectedMultiSelectItems){
                this.filteredMultiSelectItems=this.filteredMultiSelectItems.filter(item => item.Id != selecteditem.Id);
            }  
        }
        else{
            this.search(event);
        } 
    }
    else{
        this.focused=true;
    }
    }

   
    search(event) : void{
        if(this.searchText == ""){
            this.filteredMultiSelectItems=[];
           
            this.ItemNotFound=false;
            return;
        }
    
    if(!this.allowUserInput){
        this.filteredMultiSelectItems = this.multiSelectModelData.filter(item => item.name.toUpperCase().includes(this.searchText.toUpperCase()));

        this.ItemNotFound = this.filteredMultiSelectItems.length>0 ?false : true;
    }
    else{
        this.filteredMultiSelectItems = this.multiSelectModelData.filter(item => item.name.toUpperCase().includes(this.searchText.toUpperCase()));
        if(event.keyCode===13 && this.searchText !==''){
            this.selectedMultiSelectItems.push({'Id' : this.searchText , 'name' : this.searchText});
            this.SelectedItems.emit(this.selectedMultiSelectItems);
            this.filteredMultiSelectItems=[];
            this.searchText='';   
        }
        if(this.filteredMultiSelectItems && this.filteredMultiSelectItems.length==0){
            
            
            if (this.searchText.indexOf(',') > -1 && this.searchText.indexOf(',') !=0 ) { 
              const key= this.searchText.split(',');
              this.selectedMultiSelectItems.push({'Id' : key[0], 'name' : key[0]});
              this.SelectedItems.emit(this.selectedMultiSelectItems);
              this.searchText='';                  
            }
            
        }
        this.ItemNotFound=false;

    }
    
     for(let selecteditem of this.selectedMultiSelectItems){
            this.filteredMultiSelectItems=this.filteredMultiSelectItems.filter(item => item.Id != selecteditem.Id);
        }
       
    }

    selectItem(selectedItem : MultiSelect) : void{
      
        this.selectedMultiSelectItems.push(selectedItem);
        this.filteredMultiSelectItems=[];
        this.searchText='';
        this.inputfocusout(true);
         this.SelectedItems.emit(this.selectedMultiSelectItems);
       
       
         
    }
    removeItem(itemToBeRemoved :  MultiSelect): void{
        
 
        this.selectedMultiSelectItems = this.selectedMultiSelectItems.filter(item => item.Id != itemToBeRemoved.Id);
        this.SelectedItems.emit(this.selectedMultiSelectItems);
       
    }

   

}





// WEBPACK FOOTER //
// ./src/app/lib/MultiSelect-Textbox/multiselect.component.ts